import ColorChunk from '/opt/buildhome/repo/.dumi/theme/builtins/ColorChunk/index.tsx';
import API from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/API/index.js';
import Badge from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/Badge/index.js';
import CodeGroup from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/CodeGroup/index.js';
import Container from '/opt/buildhome/repo/.dumi/theme/builtins/Container/index.tsx';
import Previewer from '/opt/buildhome/repo/.dumi/theme/builtins/Previewer/index.tsx';
import SourceCode from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/SourceCode/index.js';
import Table from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/Table/index.js';
import Tree from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/Tree/index.js';
import APITable from '/opt/buildhome/repo/.dumi/theme/builtins/APITable/index.tsx';
import Audio from '/opt/buildhome/repo/.dumi/theme/builtins/Audio/index.tsx';
import ColorPalettes from '/opt/buildhome/repo/.dumi/theme/builtins/ColorPalettes/index.ts';
import ColorPaletteTool from '/opt/buildhome/repo/.dumi/theme/builtins/ColorPaletteTool/index.ts';
import ColorPaletteToolDark from '/opt/buildhome/repo/.dumi/theme/builtins/ColorPaletteToolDark/index.ts';
import ComponentMeta from '/opt/buildhome/repo/.dumi/theme/builtins/ComponentMeta/index.tsx';
import ComponentOverview from '/opt/buildhome/repo/.dumi/theme/builtins/ComponentOverview/index.tsx';
import ComponentTokenTable from '/opt/buildhome/repo/.dumi/theme/builtins/ComponentTokenTable/index.tsx';
import DemoWrapper from '/opt/buildhome/repo/.dumi/theme/builtins/DemoWrapper/index.tsx';
import IconSearch from '/opt/buildhome/repo/.dumi/theme/builtins/IconSearch/index.tsx';
import ImagePreview from '/opt/buildhome/repo/.dumi/theme/builtins/ImagePreview/index.tsx';
import InlinePopover from '/opt/buildhome/repo/.dumi/theme/builtins/InlinePopover/index.tsx';
import InstallDependencies from '/opt/buildhome/repo/.dumi/theme/builtins/InstallDependencies/index.tsx';
import LocaleLink from '/opt/buildhome/repo/.dumi/theme/builtins/LocaleLink/index.tsx';
import Palette from '/opt/buildhome/repo/.dumi/theme/builtins/Palette/index.ts';
import ResourceCards from '/opt/buildhome/repo/.dumi/theme/builtins/ResourceCards/index.tsx';
import Sandpack from '/opt/buildhome/repo/.dumi/theme/builtins/Sandpack/index.tsx';
import TokenCompare from '/opt/buildhome/repo/.dumi/theme/builtins/TokenCompare/index.tsx';
import TokenTable from '/opt/buildhome/repo/.dumi/theme/builtins/TokenTable/index.tsx';
import VideoPlayer from '/opt/buildhome/repo/.dumi/theme/builtins/VideoPlayer/index.tsx';
import { DumiDemo } from 'dumi';
import { DumiDemoGrid } from 'dumi';
import { Link } from 'dumi';

import LoadingComponent from '@@/dumi/theme/loading';
import React, { Suspense } from 'react';
import { DumiPage, useTabMeta, useRouteMeta } from 'dumi';

function DumiMarkdownInner() {
  const { texts: $$contentTexts } = useRouteMeta();

  return <><div className="markdown"><h2 id="when-to-use"><LocaleLink aria-hidden="true" tabIndex="-1" href="#when-to-use" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"When To Use"}</h2><p>{$$contentTexts[0].value}</p><h2 id="examples"><LocaleLink aria-hidden="true" tabIndex="-1" href="#examples" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"Examples"}</h2></div><DemoWrapper items={[{
  "demo": {
    "id": "attachments-demo-basic"
  },
  "previewerProps": {
    "title": "Basic",
    "filename": "components/attachments/demo/basic.tsx",
    "pkgDependencyList": {
      "@ant-design/tools": "^18.0.2",
      "@ant-design/v5-patch-for-react-19": "^1.0.3",
      "@antv/gpt-vis": "^0.4.1",
      "@biomejs/biome": "^1.9.0",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.8",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@happy-dom/jest-environment": "^17.4.3",
      "@ianvs/prettier-plugin-sort-imports": "^4.3.1",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@petercatai/assistant": "^2.0.13",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@rc-component/father-plugin": "^2.0.4",
      "@rc-component/np": "^1.0.3",
      "@rc-component/trigger": "^2.2.3",
      "@size-limit/file": "^11.1.5",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.5.0",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.5",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/inquirer": "^9.0.7",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.30",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.7",
      "@types/markdown-it": "^14.1.2",
      "@types/minimist": "^1.2.5",
      "@types/node": "^22.5.5",
      "@types/ora": "^3.2.0",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/qs": "^6.9.16",
      "@types/react": "^19.0.2",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@umijs/fabric": "^4.0.1",
      "adm-zip": "^0.5.16",
      "ali-oss": "^6.21.0",
      "antd": "^5.22.7",
      "antd-style": "^3.6.3",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "browserslist": "^4.23.3",
      "browserslist-to-esbuild": "^2.1.1",
      "chalk": "^5.4.1",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "copy-to-clipboard": "^3.3.3",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "crypto": "^1.0.1",
      "dayjs": "^1.11.13",
      "dekko": "^0.2.1",
      "dumi": "^2.4.17",
      "dumi-plugin-color-chunk": "^2.1.0",
      "esbuild-loader": "^4.2.2",
      "fast-glob": "^3.3.2",
      "father": "4.5.2",
      "fetch-jsonp": "^1.3.0",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.1.1",
      "glob": "^11.0.0",
      "happy-dom": "^17.4.3",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "inquirer": "^12.1.0",
      "is-ci": "^4.1.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-node": "^29.7.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^15.2.10",
      "lodash": "^4.17.21",
      "lottie-web": "^5.12.2",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "markdown-it": "^14.1.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.3.3",
      "prettier-plugin-jsdoc": "^1.3.0",
      "pretty-format": "^29.7.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "qs": "^6.13.0",
      "rc-drawer": "^8.0.0",
      "rc-footer": "^0.6.8",
      "rc-resize-observer": "^1.4.0",
      "rc-virtual-list": "^3.14.5",
      "react": "^19.0.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-countup": "^6.5.3",
      "react-dom": "^19.0.0",
      "react-highlight-words": "^0.20.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-intl": "7.1.6",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.0",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.0",
      "scroll-into-view-if-needed": "^3.1.0",
      "semver": "^7.6.3",
      "sharp": "^0.33.5",
      "simple-git": "^3.26.0",
      "size-limit": "^11.1.5",
      "spinnies": "^0.5.1",
      "stylelint": "^16.9.0",
      "stylelint-config-rational-order": "^0.1.2",
      "stylelint-config-standard": "^37.0.0",
      "stylelint-prettier": "^5.0.2",
      "sylvanas": "^0.6.1",
      "tar": "^7.4.3",
      "tar-fs": "^3.0.6",
      "terser": "^5.32.0",
      "tsx": "^4.19.1",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "vanilla-tilt": "^1.8.1",
      "web-streams-polyfill": "^4.0.0",
      "webpack": "^5.94.0",
      "webpack-bundle-analyzer": "^4.10.2",
      "@ant-design/colors": "^7.1.0",
      "@ant-design/cssinjs": "^1.21.1",
      "@ant-design/cssinjs-utils": "^1.1.0",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.4.0",
      "@babel/runtime": "^7.25.6",
      "classnames": "^2.5.1",
      "rc-motion": "^2.9.2",
      "rc-util": "^5.43.0"
    },
    "jsx": "import { CloudUploadOutlined, LinkOutlined } from '@ant-design/icons';\nimport { Attachments, Sender } from '@ant-design/x';\nimport { App, Button, Flex, Switch } from 'antd';\nimport React from 'react';\nconst Demo = () => {\n  const { message } = App.useApp();\n  const [fullScreenDrop, setFullScreenDrop] = React.useState(false);\n  const divRef = React.useRef(null);\n  return (\n    <Flex vertical gap=\"middle\" align=\"flex-start\" ref={divRef}>\n      <Sender\n        prefix={\n          <Attachments\n            beforeUpload={() => false}\n            onChange={({ file }) => {\n              message.info(`Mock upload: ${file.name}`);\n            }}\n            getDropContainer={() => (fullScreenDrop ? document.body : divRef.current)}\n            placeholder={{\n              icon: <CloudUploadOutlined />,\n              title: 'Drag & Drop files here',\n              description: 'Support file type: image, video, audio, document, etc.',\n            }}\n          >\n            <Button type=\"text\" icon={<LinkOutlined />} />\n          </Attachments>\n        }\n      />\n\n      <Switch\n        checked={fullScreenDrop}\n        onChange={setFullScreenDrop}\n        checkedChildren=\"Full screen drop\"\n        unCheckedChildren=\"Full screen drop\"\n      />\n    </Flex>\n  );\n};\nexport default () => (\n  <App>\n    <Demo />\n  </App>\n);\n",
    "description": "<p>Basic usage. You can use <code>getDropContainer</code> to support drag and drop upload.</p>"
  }
}, {
  "demo": {
    "id": "attachments-demo-placeholder"
  },
  "previewerProps": {
    "title": "Placeholder",
    "filename": "components/attachments/demo/placeholder.tsx",
    "pkgDependencyList": {
      "@ant-design/tools": "^18.0.2",
      "@ant-design/v5-patch-for-react-19": "^1.0.3",
      "@antv/gpt-vis": "^0.4.1",
      "@biomejs/biome": "^1.9.0",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.8",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@happy-dom/jest-environment": "^17.4.3",
      "@ianvs/prettier-plugin-sort-imports": "^4.3.1",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@petercatai/assistant": "^2.0.13",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@rc-component/father-plugin": "^2.0.4",
      "@rc-component/np": "^1.0.3",
      "@rc-component/trigger": "^2.2.3",
      "@size-limit/file": "^11.1.5",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.5.0",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.5",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/inquirer": "^9.0.7",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.30",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.7",
      "@types/markdown-it": "^14.1.2",
      "@types/minimist": "^1.2.5",
      "@types/node": "^22.5.5",
      "@types/ora": "^3.2.0",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/qs": "^6.9.16",
      "@types/react": "^19.0.2",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@umijs/fabric": "^4.0.1",
      "adm-zip": "^0.5.16",
      "ali-oss": "^6.21.0",
      "antd": "^5.22.7",
      "antd-style": "^3.6.3",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "browserslist": "^4.23.3",
      "browserslist-to-esbuild": "^2.1.1",
      "chalk": "^5.4.1",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "copy-to-clipboard": "^3.3.3",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "crypto": "^1.0.1",
      "dayjs": "^1.11.13",
      "dekko": "^0.2.1",
      "dumi": "^2.4.17",
      "dumi-plugin-color-chunk": "^2.1.0",
      "esbuild-loader": "^4.2.2",
      "fast-glob": "^3.3.2",
      "father": "4.5.2",
      "fetch-jsonp": "^1.3.0",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.1.1",
      "glob": "^11.0.0",
      "happy-dom": "^17.4.3",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "inquirer": "^12.1.0",
      "is-ci": "^4.1.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-node": "^29.7.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^15.2.10",
      "lodash": "^4.17.21",
      "lottie-web": "^5.12.2",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "markdown-it": "^14.1.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.3.3",
      "prettier-plugin-jsdoc": "^1.3.0",
      "pretty-format": "^29.7.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "qs": "^6.13.0",
      "rc-drawer": "^8.0.0",
      "rc-footer": "^0.6.8",
      "rc-resize-observer": "^1.4.0",
      "rc-virtual-list": "^3.14.5",
      "react": "^19.0.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-countup": "^6.5.3",
      "react-dom": "^19.0.0",
      "react-highlight-words": "^0.20.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-intl": "7.1.6",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.0",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.0",
      "scroll-into-view-if-needed": "^3.1.0",
      "semver": "^7.6.3",
      "sharp": "^0.33.5",
      "simple-git": "^3.26.0",
      "size-limit": "^11.1.5",
      "spinnies": "^0.5.1",
      "stylelint": "^16.9.0",
      "stylelint-config-rational-order": "^0.1.2",
      "stylelint-config-standard": "^37.0.0",
      "stylelint-prettier": "^5.0.2",
      "sylvanas": "^0.6.1",
      "tar": "^7.4.3",
      "tar-fs": "^3.0.6",
      "terser": "^5.32.0",
      "tsx": "^4.19.1",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "vanilla-tilt": "^1.8.1",
      "web-streams-polyfill": "^4.0.0",
      "webpack": "^5.94.0",
      "webpack-bundle-analyzer": "^4.10.2",
      "@ant-design/colors": "^7.1.0",
      "@ant-design/cssinjs": "^1.21.1",
      "@ant-design/cssinjs-utils": "^1.1.0",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.4.0",
      "@babel/runtime": "^7.25.6",
      "classnames": "^2.5.1",
      "rc-motion": "^2.9.2",
      "rc-util": "^5.43.0"
    },
    "jsx": "import { CloudUploadOutlined } from '@ant-design/icons';\nimport { Attachments } from '@ant-design/x';\nimport { Button, Flex, Result, theme } from 'antd';\nimport React from 'react';\nconst presetFiles = [\n  {\n    uid: '1',\n    name: 'uploading file.xlsx',\n    status: 'uploading',\n    url: 'http://www.baidu.com/xxx.png',\n    percent: 93,\n  },\n  {\n    uid: '2',\n    name: 'uploaded file.docx',\n    status: 'done',\n    size: 123456,\n    description: 'Customize description',\n    url: 'http://www.baidu.com/yyy.png',\n  },\n  {\n    uid: '3',\n    name: 'upload error with long text file name.zip',\n    status: 'error',\n    response: 'Server Error 500',\n    // custom error message to show\n    url: 'http://www.baidu.com/zzz.png',\n  },\n  {\n    uid: '4',\n    name: 'image uploading preview.png',\n    status: 'uploading',\n    percent: 33,\n    thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',\n    url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',\n  },\n  {\n    uid: '5',\n    name: 'image done preview.png',\n    status: 'done',\n    size: 123456,\n    thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',\n    url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',\n  },\n  {\n    uid: '6',\n    name: 'image error preview.png',\n    status: 'error',\n    response: 'Server Error 500',\n    // custom error message to show\n    thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',\n    url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',\n  },\n];\nconst getPlaceholderFn = (inlinePlaceholder) => {\n  return (type) =>\n    type === 'drop'\n      ? {\n          title: 'Drop file here',\n        }\n      : inlinePlaceholder;\n};\nconst Demo = () => {\n  const { token } = theme.useToken();\n  const [items, setItems] = React.useState([]);\n  const sharedBorderStyle = {\n    borderRadius: token.borderRadius,\n    overflow: 'hidden',\n    background: token.colorBgContainer,\n  };\n  const sharedAttachmentProps = {\n    beforeUpload: () => false,\n    items,\n    onChange: ({ fileList }) => {\n      console.log('onChange:', fileList);\n      setItems(fileList);\n    },\n  };\n  return (\n    <Flex\n      vertical\n      gap=\"middle\"\n      style={{\n        padding: token.padding,\n        background: token.colorBgContainerDisabled,\n      }}\n    >\n      <div style={sharedBorderStyle}>\n        <Attachments\n          {...sharedAttachmentProps}\n          placeholder={getPlaceholderFn({\n            icon: <CloudUploadOutlined />,\n            title: 'Click or Drop files here',\n            description: 'Support file type: image, video, audio, document, etc.',\n          })}\n        />\n      </div>\n\n      <div style={sharedBorderStyle}>\n        <Attachments\n          {...sharedAttachmentProps}\n          placeholder={getPlaceholderFn(\n            <Result\n              title=\"Custom Placeholder Node\"\n              icon={<CloudUploadOutlined />}\n              extra={<Button type=\"primary\">Do Upload</Button>}\n              style={{\n                padding: 0,\n              }}\n            />,\n          )}\n        />\n      </div>\n\n      <Flex gap=\"middle\">\n        <Button\n          style={{\n            flex: '1 1 50%',\n          }}\n          disabled={!!items.length}\n          type=\"primary\"\n          onClick={() => setItems(presetFiles)}\n        >\n          Fill Files\n        </Button>\n        <Button\n          style={{\n            flex: '1 1 50%',\n          }}\n          disabled={!items.length}\n          onClick={() => setItems([])}\n        >\n          Reset Files\n        </Button>\n      </Flex>\n    </Flex>\n  );\n};\nexport default Demo;\n",
    "description": "<p>Modify placeholder information.</p>"
  }
}, {
  "demo": {
    "id": "attachments-demo-overflow"
  },
  "previewerProps": {
    "title": "Overflow",
    "filename": "components/attachments/demo/overflow.tsx",
    "pkgDependencyList": {
      "@ant-design/tools": "^18.0.2",
      "@ant-design/v5-patch-for-react-19": "^1.0.3",
      "@antv/gpt-vis": "^0.4.1",
      "@biomejs/biome": "^1.9.0",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.8",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@happy-dom/jest-environment": "^17.4.3",
      "@ianvs/prettier-plugin-sort-imports": "^4.3.1",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@petercatai/assistant": "^2.0.13",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@rc-component/father-plugin": "^2.0.4",
      "@rc-component/np": "^1.0.3",
      "@rc-component/trigger": "^2.2.3",
      "@size-limit/file": "^11.1.5",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.5.0",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.5",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/inquirer": "^9.0.7",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.30",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.7",
      "@types/markdown-it": "^14.1.2",
      "@types/minimist": "^1.2.5",
      "@types/node": "^22.5.5",
      "@types/ora": "^3.2.0",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/qs": "^6.9.16",
      "@types/react": "^19.0.2",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@umijs/fabric": "^4.0.1",
      "adm-zip": "^0.5.16",
      "ali-oss": "^6.21.0",
      "antd": "^5.22.7",
      "antd-style": "^3.6.3",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "browserslist": "^4.23.3",
      "browserslist-to-esbuild": "^2.1.1",
      "chalk": "^5.4.1",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "copy-to-clipboard": "^3.3.3",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "crypto": "^1.0.1",
      "dayjs": "^1.11.13",
      "dekko": "^0.2.1",
      "dumi": "^2.4.17",
      "dumi-plugin-color-chunk": "^2.1.0",
      "esbuild-loader": "^4.2.2",
      "fast-glob": "^3.3.2",
      "father": "4.5.2",
      "fetch-jsonp": "^1.3.0",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.1.1",
      "glob": "^11.0.0",
      "happy-dom": "^17.4.3",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "inquirer": "^12.1.0",
      "is-ci": "^4.1.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-node": "^29.7.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^15.2.10",
      "lodash": "^4.17.21",
      "lottie-web": "^5.12.2",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "markdown-it": "^14.1.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.3.3",
      "prettier-plugin-jsdoc": "^1.3.0",
      "pretty-format": "^29.7.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "qs": "^6.13.0",
      "rc-drawer": "^8.0.0",
      "rc-footer": "^0.6.8",
      "rc-resize-observer": "^1.4.0",
      "rc-virtual-list": "^3.14.5",
      "react": "^19.0.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-countup": "^6.5.3",
      "react-dom": "^19.0.0",
      "react-highlight-words": "^0.20.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-intl": "7.1.6",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.0",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.0",
      "scroll-into-view-if-needed": "^3.1.0",
      "semver": "^7.6.3",
      "sharp": "^0.33.5",
      "simple-git": "^3.26.0",
      "size-limit": "^11.1.5",
      "spinnies": "^0.5.1",
      "stylelint": "^16.9.0",
      "stylelint-config-rational-order": "^0.1.2",
      "stylelint-config-standard": "^37.0.0",
      "stylelint-prettier": "^5.0.2",
      "sylvanas": "^0.6.1",
      "tar": "^7.4.3",
      "tar-fs": "^3.0.6",
      "terser": "^5.32.0",
      "tsx": "^4.19.1",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "vanilla-tilt": "^1.8.1",
      "web-streams-polyfill": "^4.0.0",
      "webpack": "^5.94.0",
      "webpack-bundle-analyzer": "^4.10.2",
      "@ant-design/colors": "^7.1.0",
      "@ant-design/cssinjs": "^1.21.1",
      "@ant-design/cssinjs-utils": "^1.1.0",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.4.0",
      "@babel/runtime": "^7.25.6",
      "classnames": "^2.5.1",
      "rc-motion": "^2.9.2",
      "rc-util": "^5.43.0"
    },
    "jsx": "import { CloudUploadOutlined } from '@ant-design/icons';\nimport { Attachments } from '@ant-design/x';\nimport { Flex, Segmented, Switch } from 'antd';\nimport React from 'react';\nconst presetFiles = Array.from({\n  length: 30,\n}).map((_, index) => ({\n  uid: String(index),\n  name: `file-${index}.jpg`,\n  status: 'done',\n  thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',\n  url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',\n}));\nconst Demo = () => {\n  const [overflow, setOverflow] = React.useState('wrap');\n  const [items, setItems] = React.useState(presetFiles);\n  const [disabled, setDisabled] = React.useState(false);\n  return (\n    <Flex vertical gap=\"middle\">\n      <Flex gap=\"middle\" align=\"center\">\n        <Segmented\n          options={[\n            {\n              value: 'wrap',\n              label: 'Wrap',\n            },\n            {\n              value: 'scrollX',\n              label: 'Scroll X',\n            },\n            {\n              value: 'scrollY',\n              label: 'Scroll Y',\n            },\n          ]}\n          value={overflow}\n          onChange={setOverflow}\n          style={{\n            marginInlineEnd: 'auto',\n          }}\n        />\n        <Switch\n          checked={items.length !== 0}\n          onChange={() => setItems((prev) => (prev.length ? [] : presetFiles))}\n          checkedChildren=\"Data\"\n          unCheckedChildren=\"Data\"\n        />\n        <Switch\n          checked={disabled}\n          onChange={setDisabled}\n          checkedChildren=\"Disabled\"\n          unCheckedChildren=\"Disabled\"\n        />\n      </Flex>\n      <Attachments\n        overflow={overflow}\n        items={items}\n        onChange={(info) => setItems(info.fileList)}\n        beforeUpload={() => false}\n        placeholder={{\n          icon: <CloudUploadOutlined />,\n          title: 'Click or Drop files here',\n          description: 'Support file type: image, video, audio, document, etc.',\n        }}\n        disabled={disabled}\n      />\n    </Flex>\n  );\n};\nexport default Demo;\n",
    "description": "<p>Controls the layout of attachments when they exceed the area.</p>"
  }
}, {
  "demo": {
    "id": "attachments-demo-with-sender"
  },
  "previewerProps": {
    "title": "Combination",
    "filename": "components/attachments/demo/with-sender.tsx",
    "pkgDependencyList": {
      "@ant-design/tools": "^18.0.2",
      "@ant-design/v5-patch-for-react-19": "^1.0.3",
      "@antv/gpt-vis": "^0.4.1",
      "@biomejs/biome": "^1.9.0",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.8",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@happy-dom/jest-environment": "^17.4.3",
      "@ianvs/prettier-plugin-sort-imports": "^4.3.1",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@petercatai/assistant": "^2.0.13",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@rc-component/father-plugin": "^2.0.4",
      "@rc-component/np": "^1.0.3",
      "@rc-component/trigger": "^2.2.3",
      "@size-limit/file": "^11.1.5",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.5.0",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.5",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/inquirer": "^9.0.7",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.30",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.7",
      "@types/markdown-it": "^14.1.2",
      "@types/minimist": "^1.2.5",
      "@types/node": "^22.5.5",
      "@types/ora": "^3.2.0",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/qs": "^6.9.16",
      "@types/react": "^19.0.2",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@umijs/fabric": "^4.0.1",
      "adm-zip": "^0.5.16",
      "ali-oss": "^6.21.0",
      "antd": "^5.22.7",
      "antd-style": "^3.6.3",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "browserslist": "^4.23.3",
      "browserslist-to-esbuild": "^2.1.1",
      "chalk": "^5.4.1",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "copy-to-clipboard": "^3.3.3",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "crypto": "^1.0.1",
      "dayjs": "^1.11.13",
      "dekko": "^0.2.1",
      "dumi": "^2.4.17",
      "dumi-plugin-color-chunk": "^2.1.0",
      "esbuild-loader": "^4.2.2",
      "fast-glob": "^3.3.2",
      "father": "4.5.2",
      "fetch-jsonp": "^1.3.0",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.1.1",
      "glob": "^11.0.0",
      "happy-dom": "^17.4.3",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "inquirer": "^12.1.0",
      "is-ci": "^4.1.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-node": "^29.7.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^15.2.10",
      "lodash": "^4.17.21",
      "lottie-web": "^5.12.2",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "markdown-it": "^14.1.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.3.3",
      "prettier-plugin-jsdoc": "^1.3.0",
      "pretty-format": "^29.7.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "qs": "^6.13.0",
      "rc-drawer": "^8.0.0",
      "rc-footer": "^0.6.8",
      "rc-resize-observer": "^1.4.0",
      "rc-virtual-list": "^3.14.5",
      "react": "^19.0.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-countup": "^6.5.3",
      "react-dom": "^19.0.0",
      "react-highlight-words": "^0.20.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-intl": "7.1.6",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.0",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.0",
      "scroll-into-view-if-needed": "^3.1.0",
      "semver": "^7.6.3",
      "sharp": "^0.33.5",
      "simple-git": "^3.26.0",
      "size-limit": "^11.1.5",
      "spinnies": "^0.5.1",
      "stylelint": "^16.9.0",
      "stylelint-config-rational-order": "^0.1.2",
      "stylelint-config-standard": "^37.0.0",
      "stylelint-prettier": "^5.0.2",
      "sylvanas": "^0.6.1",
      "tar": "^7.4.3",
      "tar-fs": "^3.0.6",
      "terser": "^5.32.0",
      "tsx": "^4.19.1",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "vanilla-tilt": "^1.8.1",
      "web-streams-polyfill": "^4.0.0",
      "webpack": "^5.94.0",
      "webpack-bundle-analyzer": "^4.10.2",
      "@ant-design/colors": "^7.1.0",
      "@ant-design/cssinjs": "^1.21.1",
      "@ant-design/cssinjs-utils": "^1.1.0",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.4.0",
      "@babel/runtime": "^7.25.6",
      "classnames": "^2.5.1",
      "rc-motion": "^2.9.2",
      "rc-util": "^5.43.0"
    },
    "jsx": "import { CloudUploadOutlined, LinkOutlined } from '@ant-design/icons';\nimport { Attachments, Sender } from '@ant-design/x';\nimport { App, Badge, Button, Flex, Typography } from 'antd';\nimport React from 'react';\nconst Demo = () => {\n  const [open, setOpen] = React.useState(true);\n  const [items, setItems] = React.useState([]);\n  const [text, setText] = React.useState('');\n  const { notification } = App.useApp();\n  const senderRef = React.useRef(null);\n  const senderHeader = (\n    <Sender.Header\n      title=\"Attachments\"\n      open={open}\n      onOpenChange={setOpen}\n      styles={{\n        content: {\n          padding: 0,\n        },\n      }}\n    >\n      <Attachments\n        // Mock not real upload file\n        beforeUpload={() => false}\n        items={items}\n        onChange={({ fileList }) => setItems(fileList)}\n        placeholder={(type) =>\n          type === 'drop'\n            ? {\n                title: 'Drop file here',\n              }\n            : {\n                icon: <CloudUploadOutlined />,\n                title: 'Upload files',\n                description: 'Click or drag files to this area to upload',\n              }\n        }\n        getDropContainer={() => senderRef.current?.nativeElement}\n      />\n    </Sender.Header>\n  );\n  return (\n    <Flex\n      style={{\n        minHeight: 250,\n      }}\n      align=\"flex-end\"\n    >\n      <Sender\n        ref={senderRef}\n        header={senderHeader}\n        prefix={\n          <Badge dot={items.length > 0 && !open}>\n            <Button onClick={() => setOpen(!open)} icon={<LinkOutlined />} />\n          </Badge>\n        }\n        value={text}\n        onChange={setText}\n        onSubmit={() => {\n          notification.info({\n            message: 'Mock Submit',\n            description: (\n              <Typography>\n                <ul>\n                  <li>You said: {text}</li>\n                  <li>\n                    Attachments count: {items.length}\n                    <ul>\n                      {items.map((item) => (\n                        <li key={item.uid}>{item.name}</li>\n                      ))}\n                    </ul>\n                  </li>\n                </ul>\n              </Typography>\n            ),\n          });\n          setItems([]);\n          setText('');\n        }}\n      />\n    </Flex>\n  );\n};\nexport default () => (\n  <App>\n    <Demo />\n  </App>\n);\n",
    "description": "<p>Work with Sender.Header to insert file into the conversation.</p>"
  }
}, {
  "demo": {
    "id": "attachments-demo-files"
  },
  "previewerProps": {
    "title": "File Card",
    "filename": "components/attachments/demo/files.tsx",
    "pkgDependencyList": {
      "@ant-design/tools": "^18.0.2",
      "@ant-design/v5-patch-for-react-19": "^1.0.3",
      "@antv/gpt-vis": "^0.4.1",
      "@biomejs/biome": "^1.9.0",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.8",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@happy-dom/jest-environment": "^17.4.3",
      "@ianvs/prettier-plugin-sort-imports": "^4.3.1",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@petercatai/assistant": "^2.0.13",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@rc-component/father-plugin": "^2.0.4",
      "@rc-component/np": "^1.0.3",
      "@rc-component/trigger": "^2.2.3",
      "@size-limit/file": "^11.1.5",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.5.0",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.5",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/inquirer": "^9.0.7",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.30",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.7",
      "@types/markdown-it": "^14.1.2",
      "@types/minimist": "^1.2.5",
      "@types/node": "^22.5.5",
      "@types/ora": "^3.2.0",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/qs": "^6.9.16",
      "@types/react": "^19.0.2",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@umijs/fabric": "^4.0.1",
      "adm-zip": "^0.5.16",
      "ali-oss": "^6.21.0",
      "antd": "^5.22.7",
      "antd-style": "^3.6.3",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "browserslist": "^4.23.3",
      "browserslist-to-esbuild": "^2.1.1",
      "chalk": "^5.4.1",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "copy-to-clipboard": "^3.3.3",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "crypto": "^1.0.1",
      "dayjs": "^1.11.13",
      "dekko": "^0.2.1",
      "dumi": "^2.4.17",
      "dumi-plugin-color-chunk": "^2.1.0",
      "esbuild-loader": "^4.2.2",
      "fast-glob": "^3.3.2",
      "father": "4.5.2",
      "fetch-jsonp": "^1.3.0",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.1.1",
      "glob": "^11.0.0",
      "happy-dom": "^17.4.3",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "inquirer": "^12.1.0",
      "is-ci": "^4.1.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-node": "^29.7.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^15.2.10",
      "lodash": "^4.17.21",
      "lottie-web": "^5.12.2",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "markdown-it": "^14.1.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.3.3",
      "prettier-plugin-jsdoc": "^1.3.0",
      "pretty-format": "^29.7.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "qs": "^6.13.0",
      "rc-drawer": "^8.0.0",
      "rc-footer": "^0.6.8",
      "rc-resize-observer": "^1.4.0",
      "rc-virtual-list": "^3.14.5",
      "react": "^19.0.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-countup": "^6.5.3",
      "react-dom": "^19.0.0",
      "react-highlight-words": "^0.20.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-intl": "7.1.6",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.0",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.0",
      "scroll-into-view-if-needed": "^3.1.0",
      "semver": "^7.6.3",
      "sharp": "^0.33.5",
      "simple-git": "^3.26.0",
      "size-limit": "^11.1.5",
      "spinnies": "^0.5.1",
      "stylelint": "^16.9.0",
      "stylelint-config-rational-order": "^0.1.2",
      "stylelint-config-standard": "^37.0.0",
      "stylelint-prettier": "^5.0.2",
      "sylvanas": "^0.6.1",
      "tar": "^7.4.3",
      "tar-fs": "^3.0.6",
      "terser": "^5.32.0",
      "tsx": "^4.19.1",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "vanilla-tilt": "^1.8.1",
      "web-streams-polyfill": "^4.0.0",
      "webpack": "^5.94.0",
      "webpack-bundle-analyzer": "^4.10.2",
      "@ant-design/colors": "^7.1.0",
      "@ant-design/cssinjs": "^1.21.1",
      "@ant-design/cssinjs-utils": "^1.1.0",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.4.0",
      "@babel/runtime": "^7.25.6",
      "classnames": "^2.5.1",
      "rc-motion": "^2.9.2",
      "rc-util": "^5.43.0"
    },
    "jsx": "import { Attachments } from '@ant-design/x';\nimport { App, Flex } from 'antd';\nimport React from 'react';\nconst Demo = () => {\n  const filesList = [\n    {\n      uid: '1',\n      name: 'excel-file.xlsx',\n      size: 111111,\n    },\n    {\n      uid: '2',\n      name: 'word-file.docx',\n      size: 222222,\n    },\n    {\n      uid: '3',\n      name: 'image-file.png',\n      size: 333333,\n    },\n    {\n      uid: '4',\n      name: 'pdf-file.pdf',\n      size: 444444,\n    },\n    {\n      uid: '5',\n      name: 'ppt-file.pptx',\n      size: 555555,\n    },\n    {\n      uid: '6',\n      name: 'video-file.mp4',\n      size: 666666,\n    },\n    {\n      uid: '7',\n      name: 'audio-file.mp3',\n      size: 777777,\n    },\n    {\n      uid: '8',\n      name: 'zip-file.zip',\n      size: 888888,\n    },\n    {\n      uid: '9',\n      name: 'markdown-file.md',\n      size: 999999,\n      description: 'Custom description here',\n    },\n    {\n      uid: '10',\n      name: 'image-file.png',\n      thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',\n      url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',\n      size: 123456,\n    },\n  ];\n  return (\n    <Flex vertical gap=\"middle\">\n      {filesList.map((file, index) => (\n        <Attachments.FileCard key={index} item={file} />\n      ))}\n    </Flex>\n  );\n};\nexport default () => (\n  <App>\n    <Demo />\n  </App>\n);\n",
    "description": "<p>A single file card, used in some display scenarios.</p>"
  }
}]} /><div className="markdown"><h2 id="api"><LocaleLink aria-hidden="true" tabIndex="-1" href="#api" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"API"}</h2><h3 id="attachmentsprops"><LocaleLink aria-hidden="true" tabIndex="-1" href="#attachmentsprops" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"AttachmentsProps"}</h3><p>{$$contentTexts[1].value}<LocaleLink href="https://ant.design/components/upload" sourceType="a">{$$contentTexts[2].value}</LocaleLink>{$$contentTexts[3].value}</p><Table className="component-api-table"><thead><tr><th>{$$contentTexts[4].value}</th><th>{$$contentTexts[5].value}</th><th>{$$contentTexts[6].value}</th><th>{$$contentTexts[7].value}</th><th>{$$contentTexts[8].value}</th></tr></thead><tbody><tr><td>{$$contentTexts[9].value}</td><td>{$$contentTexts[10].value}<LocaleLink to="#semantic-dom" sourceType="Link">{$$contentTexts[11].value}</LocaleLink></td><td>{$$contentTexts[12].value}</td><td>{$$contentTexts[13].value}</td><td>{$$contentTexts[14].value}</td></tr><tr><td>{$$contentTexts[15].value}</td><td>{$$contentTexts[16].value}</td><td>{$$contentTexts[17].value}</td><td>{$$contentTexts[18].value}</td><td>{$$contentTexts[19].value}</td></tr><tr><td>{$$contentTexts[20].value}</td><td>{$$contentTexts[21].value}</td><td>{$$contentTexts[22].value}</td><td>{$$contentTexts[23].value}</td><td>{$$contentTexts[24].value}</td></tr><tr><td>{$$contentTexts[25].value}</td><td>{$$contentTexts[26].value}<code>{$$contentTexts[27].value}</code></td><td>{$$contentTexts[28].value}</td><td>{$$contentTexts[29].value}</td><td>{$$contentTexts[30].value}</td></tr><tr><td>{$$contentTexts[31].value}</td><td>{$$contentTexts[32].value}</td><td>{$$contentTexts[33].value}</td><td>{$$contentTexts[34].value}</td><td>{$$contentTexts[35].value}</td></tr><tr><td>{$$contentTexts[36].value}</td><td>{$$contentTexts[37].value}</td><td>{$$contentTexts[38].value}</td><td>{$$contentTexts[39].value}</td><td>{$$contentTexts[40].value}</td></tr><tr><td>{$$contentTexts[41].value}</td><td>{$$contentTexts[42].value}</td><td>{$$contentTexts[43].value}</td><td>{$$contentTexts[44].value}</td><td>{$$contentTexts[45].value}</td></tr><tr><td>{$$contentTexts[46].value}</td><td>{$$contentTexts[47].value}</td><td>{$$contentTexts[48].value}</td><td>{$$contentTexts[49].value}</td><td>{$$contentTexts[50].value}</td></tr><tr><td>{$$contentTexts[51].value}</td><td>{$$contentTexts[52].value}<LocaleLink to="#semantic-dom" sourceType="Link">{$$contentTexts[53].value}</LocaleLink></td><td>{$$contentTexts[54].value}</td><td>{$$contentTexts[55].value}</td><td>{$$contentTexts[56].value}</td></tr><tr><td>{$$contentTexts[57].value}</td><td>{$$contentTexts[58].value}<LocaleLink href="https://ant.design/components/image" sourceType="a">{$$contentTexts[59].value}</LocaleLink></td><td>{$$contentTexts[60].value}</td><td>{$$contentTexts[61].value}</td><td>{$$contentTexts[62].value}</td></tr></tbody></Table><SourceCode lang="tsx">{$$contentTexts[63].value}</SourceCode><h3 id="attachmentsref"><LocaleLink aria-hidden="true" tabIndex="-1" href="#attachmentsref" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"AttachmentsRef"}</h3><Table className="component-api-table"><thead><tr><th>{$$contentTexts[64].value}</th><th>{$$contentTexts[65].value}</th><th>{$$contentTexts[66].value}</th><th>{$$contentTexts[67].value}</th></tr></thead><tbody><tr><td>{$$contentTexts[68].value}</td><td>{$$contentTexts[69].value}</td><td>{$$contentTexts[70].value}</td><td>{$$contentTexts[71].value}</td></tr><tr><td>{$$contentTexts[72].value}</td><td>{$$contentTexts[73].value}</td><td>{$$contentTexts[74].value}</td><td>{$$contentTexts[75].value}</td></tr></tbody></Table><h3 id="attachmentsfilecard-props"><LocaleLink aria-hidden="true" tabIndex="-1" href="#attachmentsfilecard-props" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"Attachments.FileCard Props"}</h3><Table className="component-api-table"><thead><tr><th>{$$contentTexts[76].value}</th><th>{$$contentTexts[77].value}</th><th>{$$contentTexts[78].value}</th><th>{$$contentTexts[79].value}</th><th>{$$contentTexts[80].value}</th></tr></thead><tbody><tr><td>{$$contentTexts[81].value}</td><td>{$$contentTexts[82].value}</td><td>{$$contentTexts[83].value}</td><td>{$$contentTexts[84].value}</td><td>{$$contentTexts[85].value}</td></tr><tr><td>{$$contentTexts[86].value}</td><td>{$$contentTexts[87].value}</td><td>{$$contentTexts[88].value}</td><td>{$$contentTexts[89].value}</td><td>{$$contentTexts[90].value}</td></tr><tr><td>{$$contentTexts[91].value}</td><td>{$$contentTexts[92].value}</td><td>{$$contentTexts[93].value}</td><td>{$$contentTexts[94].value}</td><td>{$$contentTexts[95].value}</td></tr><tr><td>{$$contentTexts[96].value}</td><td>{$$contentTexts[97].value}<code>{$$contentTexts[98].value}</code></td><td>{$$contentTexts[99].value}</td><td>{$$contentTexts[100].value}</td><td>{$$contentTexts[101].value}</td></tr><tr><td>{$$contentTexts[102].value}</td><td>{$$contentTexts[103].value}</td><td>{$$contentTexts[104].value}</td><td>{$$contentTexts[105].value}</td><td>{$$contentTexts[106].value}</td></tr><tr><td>{$$contentTexts[107].value}</td><td>{$$contentTexts[108].value}<LocaleLink href="https://ant.design/components/image" sourceType="a">{$$contentTexts[109].value}</LocaleLink></td><td>{$$contentTexts[110].value}</td><td>{$$contentTexts[111].value}</td><td>{$$contentTexts[112].value}</td></tr></tbody></Table><h2 id="semantic-dom"><LocaleLink aria-hidden="true" tabIndex="-1" href="#semantic-dom" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"Semantic DOM"}</h2></div><DumiDemo {...{
  "demo": {
    "id": "attachments-demo-_semantic"
  },
  "previewerProps": {
    "simplify": "true",
    "filename": "components/attachments/demo/_semantic.tsx",
    "pkgDependencyList": {
      "@ant-design/tools": "^18.0.2",
      "@ant-design/v5-patch-for-react-19": "^1.0.3",
      "@antv/gpt-vis": "^0.4.1",
      "@biomejs/biome": "^1.9.0",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.8",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@happy-dom/jest-environment": "^17.4.3",
      "@ianvs/prettier-plugin-sort-imports": "^4.3.1",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@petercatai/assistant": "^2.0.13",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@rc-component/father-plugin": "^2.0.4",
      "@rc-component/np": "^1.0.3",
      "@rc-component/trigger": "^2.2.3",
      "@size-limit/file": "^11.1.5",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.5.0",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.5",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/inquirer": "^9.0.7",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.30",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.7",
      "@types/markdown-it": "^14.1.2",
      "@types/minimist": "^1.2.5",
      "@types/node": "^22.5.5",
      "@types/ora": "^3.2.0",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/qs": "^6.9.16",
      "@types/react": "^19.0.2",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@umijs/fabric": "^4.0.1",
      "adm-zip": "^0.5.16",
      "ali-oss": "^6.21.0",
      "antd": "^5.22.7",
      "antd-style": "^3.6.3",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "browserslist": "^4.23.3",
      "browserslist-to-esbuild": "^2.1.1",
      "chalk": "^5.4.1",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "copy-to-clipboard": "^3.3.3",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "crypto": "^1.0.1",
      "dayjs": "^1.11.13",
      "dekko": "^0.2.1",
      "dumi": "^2.4.17",
      "dumi-plugin-color-chunk": "^2.1.0",
      "esbuild-loader": "^4.2.2",
      "fast-glob": "^3.3.2",
      "father": "4.5.2",
      "fetch-jsonp": "^1.3.0",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.1.1",
      "glob": "^11.0.0",
      "happy-dom": "^17.4.3",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "inquirer": "^12.1.0",
      "is-ci": "^4.1.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-node": "^29.7.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^15.2.10",
      "lodash": "^4.17.21",
      "lottie-web": "^5.12.2",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "markdown-it": "^14.1.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.3.3",
      "prettier-plugin-jsdoc": "^1.3.0",
      "pretty-format": "^29.7.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "qs": "^6.13.0",
      "rc-drawer": "^8.0.0",
      "rc-footer": "^0.6.8",
      "rc-resize-observer": "^1.4.0",
      "rc-virtual-list": "^3.14.5",
      "react": "^19.0.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-countup": "^6.5.3",
      "react-dom": "^19.0.0",
      "react-highlight-words": "^0.20.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-intl": "7.1.6",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.0",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.0",
      "scroll-into-view-if-needed": "^3.1.0",
      "semver": "^7.6.3",
      "sharp": "^0.33.5",
      "simple-git": "^3.26.0",
      "size-limit": "^11.1.5",
      "spinnies": "^0.5.1",
      "stylelint": "^16.9.0",
      "stylelint-config-rational-order": "^0.1.2",
      "stylelint-config-standard": "^37.0.0",
      "stylelint-prettier": "^5.0.2",
      "sylvanas": "^0.6.1",
      "tar": "^7.4.3",
      "tar-fs": "^3.0.6",
      "terser": "^5.32.0",
      "tsx": "^4.19.1",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "vanilla-tilt": "^1.8.1",
      "web-streams-polyfill": "^4.0.0",
      "webpack": "^5.94.0",
      "webpack-bundle-analyzer": "^4.10.2",
      "@ant-design/colors": "^7.1.0",
      "@ant-design/cssinjs": "^1.21.1",
      "@ant-design/cssinjs-utils": "^1.1.0",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.4.0",
      "@babel/runtime": "^7.25.6",
      "classnames": "^2.5.1",
      "rc-motion": "^2.9.2",
      "rc-util": "^5.43.0"
    },
    "jsx": "import { CloudUploadOutlined } from '@ant-design/icons';\nimport { Attachments } from '@ant-design/x';\nimport { Divider, Flex } from 'antd';\nimport React from 'react';\nimport SemanticPreview from '../../../.dumi/components/SemanticPreview';\nimport useLocale from '../../../.dumi/hooks/useLocale';\nconst placeholderLocales = {\n  cn: {\n    placeholder: '占位符',\n  },\n  en: {\n    placeholder: 'Placeholder',\n  },\n};\nconst withItemLocales = {\n  cn: {\n    list: '列表容器',\n    item: '列表项',\n  },\n  en: {\n    list: 'List container',\n    item: 'List item',\n  },\n};\nconst items = Array.from({\n  length: 3,\n}).map((_, index) => ({\n  uid: String(index),\n  name: `file-${index}.jpg`,\n  status: 'done',\n  thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',\n  url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',\n}));\nconst App = () => {\n  const [placeholderLocale] = useLocale(placeholderLocales);\n  const [withItemLocale] = useLocale(withItemLocales);\n  return (\n    <Flex vertical>\n      <SemanticPreview\n        semantics={[\n          {\n            name: 'placeholder',\n            desc: placeholderLocale.placeholder,\n          },\n        ]}\n      >\n        <Attachments\n          placeholder={{\n            icon: <CloudUploadOutlined />,\n            title: 'Upload File',\n            description: 'Drag or click to upload file.',\n          }}\n        />\n      </SemanticPreview>\n      <Divider\n        style={{\n          margin: 0,\n          padding: 0,\n        }}\n      />\n      <SemanticPreview\n        semantics={[\n          {\n            name: 'list',\n            desc: withItemLocale.list,\n          },\n          {\n            name: 'item',\n            desc: withItemLocale.item,\n          },\n        ]}\n      >\n        <Attachments items={items} />\n      </SemanticPreview>\n    </Flex>\n  );\n};\nexport default App;\n"
  }
}} /><div className="markdown"><h2 id="design-token"><LocaleLink aria-hidden="true" tabIndex="-1" href="#design-token" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"Design Token"}</h2></div><ComponentTokenTable component="Attachments" /></>;
}

// export named function for fastRefresh
// ref: https://github.com/pmmmwh/react-refresh-webpack-plugin/blob/main/docs/TROUBLESHOOTING.md#edits-always-lead-to-full-reload
function DumiMarkdownContent() {
  // wrap suspense for catch async meta data
  return <DumiPage><Suspense fallback={<LoadingComponent />}><DumiMarkdownInner /></Suspense></DumiPage>;
}

export default DumiMarkdownContent;